import { render, staticRenderFns } from "./ValidationAsDialog.vue?vue&type=template&id=71841195&"
import script from "./ValidationAsDialog.vue?vue&type=script&lang=js&"
export * from "./ValidationAsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports